module.exports = __webpack_public_path__ + "img/MarketIcon.71db625c.svg";